import React from 'react';
import Error from 'next/error';
import Loader from '@24i/nxg-sdk-gluons/src/components/ui/Loader';
import { NextError404ScreenProps } from '../types';

export default function Error404({ isFalse404 }: NextError404ScreenProps) {
    if (isFalse404) return <Loader />;
    return <Error statusCode={404} />;
}
